import React, { createContext, useContext, useState } from 'react';
import { Toast } from '../components/Toast';

interface ToastContextType {
  showToast: (message: string, type: 'success' | 'error' | 'info', icon?: React.ReactNode, autoClose?: boolean) => void;
  success: (message: string, icon?: React.ReactNode, autoClose?: boolean) => void;
  error: (message: string, icon?: React.ReactNode, autoClose?: boolean) => void;
  info: (message: string, icon?: React.ReactNode, autoClose?: boolean) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toast, setToast] = useState<{ 
    message: string; 
    type: 'success' | 'error' | 'info';
    icon?: React.ReactNode;
    autoClose?: boolean;
  } | null>(null);

  // Fonction pour afficher un toast avec un message et un type
  const showToast = (message: string, type: 'success' | 'error' | 'info', icon?: React.ReactNode, autoClose: boolean = true) => {
    // S'assurer que le message n'est jamais vide
    const safeMessage = message || (type === 'error' ? 'Une erreur est survenue' : 'Opération réussie');
    
    // Afficher un message de débogage ici
    
    // Utiliser setTimeout pour s'assurer que le toast est affiché même si un autre toast est déjà affiché
    setTimeout(() => {
      setToast({ message: safeMessage, type, icon, autoClose });
    }, 100);
  };

  const success = (message: string, icon?: React.ReactNode, autoClose: boolean = true) => {
    showToast(message, 'success', icon, autoClose);
  };

  const error = (message: string, icon?: React.ReactNode, autoClose: boolean = true) => {
    showToast(message, 'error', icon, autoClose);
  };

  const info = (message: string, icon?: React.ReactNode, autoClose: boolean = true) => {
    showToast(message, 'info', icon, autoClose);
  };

  return (
    <ToastContext.Provider value={{ showToast, success, error, info }}>
      {children}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          icon={toast.icon}
          autoClose={toast.autoClose}
          onClose={() => setToast(null)}
        />
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
